import { setupLayouts } from 'virtual:generated-layouts'
import { createRouter, createWebHistory } from 'vue-router'
import { isUserLoggedIn } from './utils'
import axios from '@axios'
import { canNavigate } from '@layouts/plugins/casl'
import routes from '~pages'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to) {
    if (to.hash)
      return { el: to.hash, behavior: 'smooth', top: 60 }

    return { top: 0 }
  },
  routes: [
    ...setupLayouts(routes),
  ],
})

router.beforeEach((to, from) => {
  if (to.meta.public)
    return

  const isLoggedIn = isUserLoggedIn()
  if (!isLoggedIn && to.name !== 'login' && to.name !== 'registrar-usuario' && to.name !== 'esqueceu-senha' && to.name !== 'redefinir-senha')
    return { name: 'login' }

  if (isLoggedIn && to.name === 'login')
    return '/'

  if (to.name !== 'login') {
    axios.get('logado').catch(() => {
      localStorage.removeItem('accessToken')
      localStorage.removeItem('userData')

      return { name: 'login' }
    })
  }

  if (canNavigate(to)) {
    if (to.meta.redirectIfLoggedIn && isLoggedIn) {}
  }
  else {
    if (isLoggedIn)
      return { name: 'not-authorized' }
  }
})

// Docs: https://router.vuejs.org/guide/advanced/navigation-guards.html#global-before-guards

export default router
